import React from 'react';
import { BaseActionSheet } from './base-action-sheet';
import { createStyles } from '@/contexts/theme-context';
import { List } from './list';
import { ScannerListOption } from '@/hooks/use-scanner-operations';

export interface Props {
  onClose: () => void;
  operations: ScannerListOption[];
}

export const ScannerOperationsActionSheet: React.FC<Props> = ({
  onClose,
  operations,
}) => {
  const [styles, theme] = useStyles();
  return (
    <BaseActionSheet contentStyle={styles.base} isVisible onClose={onClose}>
      <List<ScannerListOption>
        data={operations}
        listItemTitleStyle={(item) => {
          const { disabled } = item.metadata!;
          return disabled ? styles.disabledTitle : undefined;
        }}
        onSelect={(item) => {
          item.metadata?.onPress();
          onClose();
        }}
        renderLeftComponent={(item) => {
          const { Icon, disabled } = item.metadata!;
          return Icon ? (
            <Icon
              stroke={
                disabled
                  ? theme.sk.color.icon.disabled
                  : theme.sk.color.icon.primary
              }
            />
          ) : null;
        }}
      />
    </BaseActionSheet>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    paddingHorizontal: 0,
    paddingTop: 24,
  },
  disabledTitle: {
    color: theme.sk.color.text.disabled,
  },
}));
